import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import '@fontsource/merriweather';
import "react-toastify/dist/ReactToastify.css";
import { AppThemeProvider } from './context/AppThemeContext';
import { TenantProvider } from './context/TenantContext';
import { UsageTrackerProvider } from './context/UsageTrackerContext';
import GlobalErrorBoundary from './components/GlobalErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<GlobalErrorBoundary>
		<AppThemeProvider>
			<TenantProvider>
				<UsageTrackerProvider>
					<App />
				</UsageTrackerProvider>
			</TenantProvider>
		</AppThemeProvider>
	</GlobalErrorBoundary>
);
